import script from "./ConfirmStockInTransitModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfirmStockInTransitModal.vue?vue&type=script&lang=ts&setup=true"

import "./ConfirmStockInTransitModal.vue?vue&type=style&index=0&id=108d73ca&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-108d73ca"]])

export default __exports__